module.exports = __webpack_public_path__ + "static/media/r32.5b33155d.jpg";